<template>
<div class="chapter">
<div class="inner_page">
<div id="cover-image">
<img alt="The Camera Lies" class="cover-image" src="images/ab-morgan---the-camera-lies_cover_high-res.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?29990674